import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePackageTransferMutationVariables = GraphQLTypes.Exact<{
  packageId: GraphQLTypes.Scalars['String'];
  id: GraphQLTypes.Scalars['String'];
  packageTransferInput: GraphQLTypes.UpdateTransferPackageInput;
}>;


export type UpdatePackageTransferMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'updatePackageTransfer'>
);


export const UpdatePackageTransferDocument = /*#__PURE__*/ gql`
    mutation updatePackageTransfer($packageId: String!, $id: String!, $packageTransferInput: UpdateTransferPackageInput!) {
  updatePackageTransfer(
    packageId: $packageId
    id: $id
    packageTransferInput: $packageTransferInput
  )
}
    `;

/**
 * __useUpdatePackageTransferMutation__
 *
 * To run a mutation, you first call `useUpdatePackageTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageTransferMutation, { data, loading, error }] = useUpdatePackageTransferMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      id: // value for 'id'
 *      packageTransferInput: // value for 'packageTransferInput'
 *   },
 * });
 */
export function useUpdatePackageTransferMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageTransferMutationResult, UpdatePackageTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageTransferMutationResult, UpdatePackageTransferMutationVariables>(UpdatePackageTransferDocument, options);
      }
export type UpdatePackageTransferMutationHookResult = ReturnType<typeof useUpdatePackageTransferMutation>;